<template>
    <div :class="{ 'disabled-picker': disabled }">
        <date-range-picker
            v-model="dateRangeLocal"
            :maxDate="maxDate"
            :minDate="minDate"
            :locale-data="locale_data"
            :opens="opens"
            :timePicker="enableTime"
            :timePicker24Hour="enableTime"
            :timePickerSeconds="enableTime"
            :timePickerIncrement="1"
            :date-format="dateFormat"
            @update="updateDate"
        />
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    export default {
        props: {
            disabledDates: {
                type: Array,
                default: () => []
            },
            dateRange: { 
                type: Object,
                default: () => {}
            },
            maxDate : {
                type: [String, Date]
            },
            minDate: {
                type: [String, Date]
            },
            disabled: {
                type: Boolean,
                default: false
            },
            opens: {
                type: String,
                default: 'right'
            },
            enableTime: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dateRangeLocal: { ...this.dateRange },
                locale_data: {
                    direction: 'ltr',
                    format: 'dd/mm/yyyy',
                    separator: ' - ',
                    applyLabel: 'Seleccionar',
                    cancelLabel: 'Cancelar',
                    weekLabel: 'W',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: ['Dom','Lun', 'Mar', 'Miérc', 'Juev', 'Vier', 'Sáb'],
                    monthNames: ['En', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Ag', 'Sept', 'Oct', 'Nov', 'Dec'],
                    firstDay: 1
                }
            }
        },
        methods: {
            updateDate() {
                if (this.dateRangeLocal.startDate && this.dateRangeLocal.endDate) {
                    if (this.enableTime) {
                        this.$emit('selected', {
                            startDate: moment(this.dateRangeLocal.startDate).local().format('YYYY-MM-DD HH:mm:ss'),
                            endDate: moment(this.dateRangeLocal.endDate).local().format('YYYY-MM-DD HH:mm:ss')
                        })
                    } 
                    else {
                        this.$emit('selected', {
                            startDate: moment(this.dateRangeLocal.startDate).format('MM-DD-YYYY'),
                            endDate: moment(this.dateRangeLocal.endDate).format('MM-DD-YYYY')
                        })
                    }      
                }
            },
            dateFormat(classes, date) {
                if (!classes.disabled) {
                    let mes = date.getMonth() + 1;
                    let dia = date.getDate();
                    let dat = mes.toString().padStart(2, '0') + '-' + dia.toString().padStart(2, '0') + '-' + date.getFullYear();

                    classes.disabled = this.disabledDates.includes(dat);
                }
                return classes
            }
        },
        created() {
            if (this.enableTime) {
                this.locale_data.format = 'dd/mm/yyyy HH:MM:ss'
            }

            this.updateDate();
        },
        components: { 
            DateRangePicker
        }
    }
</script>

<style scoped>
    .vue-daterange-picker {
        width: 100%;
    }
    .disabled-picker {
        pointer-events: none;
        opacity: 0.5;
    }
</style>